import React from "react"
import {} from "./style"
import { FlexGrid, FlexRow, FlexCol } from "../FlexGrid"
import { getTags } from "../../utils/helpers"
import { Block, Title } from "./style"

import { TeaserLarge } from "../TeaserLarge"

const RelatedContent = ({ title, pages }) => {
  return (
    <Block>
      <FlexGrid gap={[20, 30, 60]} rowGap={[38, 38, 48]}>
        <FlexRow center="xs">
          {title && (
            <FlexCol xs={12}>
              <Title>{title}</Title>
            </FlexCol>
          )}

          {pages.map((page, index) => {

            if(!page) return null;
            return (
              <FlexCol xs={12} sm={6} key={index}>
                <TeaserLarge
                  title={page.title}
                  img={page.featuredImage}
                  tag={getTags(page.categories.nodes)}
                  link={page.link}
                  theme="index"
                />
              </FlexCol>
            )
          })}
        </FlexRow>
      </FlexGrid>
    </Block>
  )
}

export default RelatedContent
